import React, { useEffect, useState } from "react";

import {
  FaWallet,
  FaFutbol,
  FaChevronDown,
  FaEye,
  FaEyeSlash,
} from "react-icons/fa";

import {
  collection,
  query,
  where,
  onSnapshot,
} from "firebase/firestore";

import { useNavigate } from "react-router-dom";
import { db } from "../firebase";
import "./BalanceCard.css";

const translations = {
  en: {
    estimatedBalance: "Estimated Balance",
    todaysProfit: "Today's Profit",
    deposit: "Deposit",
    marketTrade: "MarketTrade",
    showUsername: "Show username",
    hideUsername: "Hide username",
  },
  fr: {
    estimatedBalance: "Solde estimé",
    todaysProfit: "Profit du jour",
    deposit: "Dépôt",
    marketTrade: "Marché",
    showUsername: "Afficher le nom d'utilisateur",
    hideUsername: "Masquer le nom d'utilisateur",
  },
  sw: {
    estimatedBalance: "Salio Linalokadiriwa",
    todaysProfit: "Faida ya Leo",
    deposit: "Weka Pesa",
    marketTrade: "Soko",
    showUsername: "Onyesha jina la mtumiaji",
    hideUsername: "Ficha jina la mtumiaji",
  },
  pt: {
    estimatedBalance: "Saldo Estimado",
    todaysProfit: "Lucro de Hoje",
    deposit: "Depositar",
    marketTrade: "Mercado",
    showUsername: "Mostrar nome de usuário",
    hideUsername: "Ocultar nome de usuário",
  },
  es: {
    estimatedBalance: "Saldo estimado",
    todaysProfit: "Ganancias de hoy",
    deposit: "Depositar",
    marketTrade: "Mercado",
    showUsername: "Mostrar nombre de usuario",
    hideUsername: "Ocultar nombre de usuario",
  },
  ar: {
    estimatedBalance: "الرصيد التقديري",
    todaysProfit: "أرباح اليوم",
    deposit: "إيداع",
    marketTrade: "السوق",
    showUsername: "إظهار اسم المستخدم",
    hideUsername: "إخفاء اسم المستخدم",
  },
  zh: {
    estimatedBalance: "预计余额",
    todaysProfit: "今日收益",
    deposit: "存款",
    marketTrade: "市场",
    showUsername: "显示用户名",
    hideUsername: "隐藏用户名",
  },
  hi: {
    estimatedBalance: "अनुमानित बैलेंस",
    todaysProfit: "आज का लाभ",
    deposit: "जमा करें",
    marketTrade: "बाज़ार",
    showUsername: "उपयोगकर्ता नाम दिखाएँ",
    hideUsername: "उपयोगकर्ता नाम छिपाएँ",
  },
  bn: {
    estimatedBalance: "আনুমানিক ব্যালেন্স",
    todaysProfit: "আজকের লাভ",
    deposit: "জমা দিন",
    marketTrade: "বাজার",
    showUsername: "ব্যবহারকারীর নাম দেখান",
    hideUsername: "ব্যবহারকারীর নাম লুকান",
  },
  ru: {
    estimatedBalance: "Расчётный баланс",
    todaysProfit: "Прибыль за сегодня",
    deposit: "Пополнить",
    marketTrade: "Рынок",
    showUsername: "Показать имя пользователя",
    hideUsername: "Скрыть имя пользователя",
  },
  de: {
    estimatedBalance: "Geschätztes Guthaben",
    todaysProfit: "Heutiger Gewinn",
    deposit: "Einzahlen",
    marketTrade: "Markt",
    showUsername: "Benutzernamen anzeigen",
    hideUsername: "Benutzernamen verbergen",
  },
  it: {
    estimatedBalance: "Saldo stimato",
    todaysProfit: "Profitto di oggi",
    deposit: "Deposita",
    marketTrade: "Mercato",
    showUsername: "Mostra nome utente",
    hideUsername: "Nascondi nome utente",
  },
  nl: {
    estimatedBalance: "Geschat saldo",
    todaysProfit: "Winst van vandaag",
    deposit: "Storten",
    marketTrade: "Markt",
    showUsername: "Gebruikersnaam tonen",
    hideUsername: "Gebruikersnaam verbergen",
  },
  tr: {
    estimatedBalance: "Tahmini Bakiye",
    todaysProfit: "Bugünkü Kâr",
    deposit: "Para Yatır",
    marketTrade: "Piyasa",
    showUsername: "Kullanıcı adını göster",
    hideUsername: "Kullanıcı adını gizle",
  },
  ja: {
    estimatedBalance: "推定残高",
    todaysProfit: "本日の利益",
    deposit: "入金",
    marketTrade: "マーケット",
    showUsername: "ユーザー名を表示",
    hideUsername: "ユーザー名を隠す",
  },
  ko: {
    estimatedBalance: "예상 잔액",
    todaysProfit: "오늘의 수익",
    deposit: "입금",
    marketTrade: "마켓",
    showUsername: "사용자 이름 표시",
    hideUsername: "사용자 이름 숨기기",
  },
  vi: {
    estimatedBalance: "Số dư ước tính",
    todaysProfit: "Lợi nhuận hôm nay",
    deposit: "Nạp tiền",
    marketTrade: "Thị trường",
    showUsername: "Hiện tên người dùng",
    hideUsername: "Ẩn tên người dùng",
  },
  th: {
    estimatedBalance: "ยอดเงินโดยประมาณ",
    todaysProfit: "กำไรวันนี้",
    deposit: "ฝากเงิน",
    marketTrade: "ตลาด",
    showUsername: "แสดงชื่อผู้ใช้",
    hideUsername: "ซ่อนชื่อผู้ใช้",
  },
  id: {
    estimatedBalance: "Saldo Perkiraan",
    todaysProfit: "Keuntungan Hari Ini",
    deposit: "Deposit",
    marketTrade: "Pasar",
    showUsername: "Tampilkan nama pengguna",
    hideUsername: "Sembunyikan nama pengguna",
  },
  ms: {
    estimatedBalance: "Baki Anggaran",
    todaysProfit: "Keuntungan Hari Ini",
    deposit: "Deposit",
    marketTrade: "Pasaran",
    showUsername: "Tunjukkan nama pengguna",
    hideUsername: "Sembunyikan nama pengguna",
  },
  ur: {
    estimatedBalance: "تخمینی بیلنس",
    todaysProfit: "آج کا منافع",
    deposit: "رقم جمع کریں",
    marketTrade: "مارکیٹ",
    showUsername: "صارف کا نام دکھائیں",
    hideUsername: "صارف کا نام چھپائیں",
  },
  fa: {
    estimatedBalance: "موجودی تخمینی",
    todaysProfit: "سود امروز",
    deposit: "واریز",
    marketTrade: "بازار",
    showUsername: "نمایش نام کاربری",
    hideUsername: "پنهان کردن نام کاربری",
  },
  ha: {
    estimatedBalance: "Ma'aunin Kuɗi",
    todaysProfit: "Ribar Yau",
    deposit: "Ajiye Kuɗi",
    marketTrade: "Kasuwa",
    showUsername: "Nuna sunan mai amfani",
    hideUsername: "Ɓoye sunan mai amfani",
  },
  yo: {
    estimatedBalance: "Ìwọ̀n Owó",
    todaysProfit: "Èrè Òní",
    deposit: "Fi Owó Sílẹ̀",
    marketTrade: "Ọjà",
    showUsername: "Fi orúkọ olumulo hàn",
    hideUsername: "Fi orúkọ olumulo pamọ́",
  },
  zu: {
    estimatedBalance: "Ibhalansi Elinganiselwe",
    todaysProfit: "Inzuzo Yanamuhla",
    deposit: "Faka Imali",
    marketTrade: "Imakethe",
    showUsername: "Bonisa igama lomsebenzisi",
    hideUsername: "Fihla igama lomsebenzisi",
  },
  am: {
    estimatedBalance: "የተገመተ ቀሪ ሂሳብ",
    todaysProfit: "የዛሬ ትርፍ",
    deposit: "ገንዘብ አስገባ",
    marketTrade: "ገበያ",
    showUsername: "የተጠቃሚ ስም አሳይ",
    hideUsername: "የተጠቃሚ ስም ደብቅ",
  },
  so: {
    estimatedBalance: "Hadhaaga La Qiyaasay",
    todaysProfit: "Faa'iidada Maanta",
    deposit: "Lacag Dhigasho",
    marketTrade: "Suuqa",
    showUsername: "Muuji magaca isticmaalaha",
    hideUsername: "Qari magaca isticmaalaha",
  },
  rw: {
    estimatedBalance: "Amafaranga Agenewe",
    todaysProfit: "Inyungu y'Uyu Munsi",
    deposit: "Shyiramo Amafaranga",
    marketTrade: "Isoko",
    showUsername: "Erekana izina ry'ukoresha",
    hideUsername: "Hisha izina ry'ukoresha",
  },
  lg: {
    estimatedBalance: "Ssente Ezibaliriddwa",
    todaysProfit: "Amagoba g'Olwaleero",
    deposit: "Teekamu Ssente",
    marketTrade: "Akataale",
    showUsername: "Laga erinnya ly'omukozesa",
    hideUsername: "Kweka erinnya ly'omukozesa",
  },
  af: {
    estimatedBalance: "Geskatte balans",
    todaysProfit: "Vandag se wins",
    deposit: "Deponeer",
    marketTrade: "Mark",
    showUsername: "Wys gebruikersnaam",
    hideUsername: "Versteek gebruikersnaam",
  },
};

const fieldMap = {
  TZS: "tshBalance",
  USDT: "usdtBalance",
  KES: "KESBalance",
  UGX: "UGXBalance",
  RWF: "RWFBalance",
  BIF: "BIFBalance",
  ZMW: "ZMWBalance",
  MWK: "MWKBalance",
  MZN: "MZNBalance",
  USD: "USDBalance",
  SSP: "SSPBalance",
  BWP: "BWPBalance",
  MGA: "MGABalance",
};

const BalanceCard = () => {
  const navigate = useNavigate();

  // LANGUAGE
  const [language, setLanguage] = useState(
    () => localStorage.getItem("language") || "en"
  );

  useEffect(() => {
    const updateLanguage = () => {
      setLanguage(localStorage.getItem("language") || "en");
    };

    window.addEventListener("languageChanged", updateLanguage);
    window.addEventListener("storage", updateLanguage);

    return () => {
      window.removeEventListener("languageChanged", updateLanguage);
      window.removeEventListener("storage", updateLanguage);
    };
  }, []);

  const t = translations[language] || translations.en;

  // BALANCE STATE
  const [balances, setBalances] = useState({});
  const [balanceLoading, setBalanceLoading] = useState(true);
  const [selectedCurrency, setSelectedCurrency] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);

  // USERNAME STATE
  const [username, setUsername] = useState("");
  const [showUsername, setShowUsername] = useState(false);

  // LOAD USERNAME
  useEffect(() => {
    const savedUsername = localStorage.getItem("username");

    if (savedUsername) {
      setUsername(savedUsername);
    }
  }, []);

  // MASK USERNAME
  const maskUsername = (name) => {
    if (!name) return "";

    if (name.length <= 2) {
      return name;
    }

    if (name.length <= 4) {
      return name.substring(0, 2) + "*";
    }

    const firstTwo = name.substring(0, 2);
    const lastTwo = name.substring(name.length - 2);

    return firstTwo + "***" + lastTwo;
  };

  // TOGGLE USERNAME
  const toggleUsername = () => {
    setShowUsername((previous) => !previous);
  };

  // LOAD BALANCES REAL-TIME
  useEffect(() => {
    const savedUsername = localStorage.getItem("username");

    if (!savedUsername) {
      setBalances({});
      setBalanceLoading(false);
      return;
    }

    const userQuery = query(
      collection(db, "users"),
      where("username", "==", savedUsername)
    );

    const unsubscribe = onSnapshot(
      userQuery,
      (snapshot) => {
        if (snapshot.empty) {
          setBalances({});
          setBalanceLoading(false);
          return;
        }

        const userData = snapshot.docs[0].data();
        const loadedBalances = {};

        Object.entries(fieldMap).forEach(([currency, field]) => {
          const value = Number(userData[field] ?? 0);

          loadedBalances[currency] = Number.isFinite(value)
            ? value
            : 0;
        });

        setBalances(loadedBalances);
        setBalanceLoading(false);
      },
      (error) => {
        console.error(
          "BalanceCard real-time balance error:",
          error
        );

        setBalances({});
        setBalanceLoading(false);
      }
    );

    return () => {
      unsubscribe();
    };
  }, []);

  // AVAILABLE BALANCES
  const availableBalances = Object.entries(balances)
    .filter(([, value]) => Number(value || 0) > 0)
    .map(([currency, balance]) => ({
      currency,
      balance: Number(balance || 0),
    }));

  // DEFAULT SELECTED CURRENCY
  useEffect(() => {
    if (availableBalances.length === 0) {
      setSelectedCurrency(null);
      return;
    }

    const stillAvailable = availableBalances.some(
      (item) => item.currency === selectedCurrency
    );

    if (!stillAvailable) {
      setSelectedCurrency(availableBalances[0].currency);
    }
  }, [balances, selectedCurrency]);

  // FORMAT MONEY
  const formatMoney = (value) => {
    const number = Number(value ?? 0);

    if (!Number.isFinite(number)) {
      return "0.00";
    }

    return number.toLocaleString("en-GB", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  // CURRENT BALANCE
  const getCurrentBalance = () => {
    if (availableBalances.length === 0) {
      return {
        currency: "TZS",
        balance: 0,
      };
    }

    const selected = availableBalances.find(
      (item) => item.currency === selectedCurrency
    );

    return selected || availableBalances[0];
  };

  const currentBalance = getCurrentBalance();

  // MULTIPLE BALANCES
  const hasMultipleBalances = availableBalances.length > 1;

  // BALANCE CLICK
  const handleBalanceClick = () => {
    if (hasMultipleBalances) {
      setMenuOpen((previous) => !previous);
      return;
    }

    navigate("/all-pages");
  };

  // SELECT CURRENCY
  const handleSelectCurrency = (currency) => {
    setSelectedCurrency(currency);
    setMenuOpen(false);
  };

  // DEPOSIT
  const handleDeposit = () => {
    navigate("/deposit");
  };

  // MARKET TRADE
  const handleMarketTrade = () => {
    navigate("/sports");
  };

  return (
    <div className="balance-card">
      {/* USERNAME */}
      {username && (
        <div className="balance-username-top">
          <span>
            {showUsername ? username : maskUsername(username)}
          </span>

          <button
            type="button"
            className="username-eye-btn"
            onClick={toggleUsername}
            aria-label={
              showUsername
                ? t.hideUsername
                : t.showUsername
            }
          >
            {showUsername ? <FaEyeSlash /> : <FaEye />}
          </button>
        </div>
      )}

      {/* BALANCE TOP */}
      <div className="balance-top">
        <div className="balance-left">
          <p className="balance-title">
            {t.estimatedBalance}
          </p>

          <button
            type="button"
            className="balance-amount-button"
            onClick={handleBalanceClick}
          >
            <span className="balance-currency">
              {currentBalance.currency}
            </span>

            <span className="balance-amount">
              {formatMoney(currentBalance.balance)}
            </span>

            {hasMultipleBalances && (
              <FaChevronDown
                className={
                  menuOpen
                    ? "balance-arrow rotate"
                    : "balance-arrow"
                }
              />
            )}
          </button>

          {/* BALANCE MENU */}
          {menuOpen && hasMultipleBalances && (
            <div className="balance-menu">
              {availableBalances.map((item) => {
                const active =
                  item.currency === selectedCurrency;

                return (
                  <button
                    type="button"
                    key={item.currency}
                    className={
                      active
                        ? "balance-option active"
                        : "balance-option"
                    }
                    onClick={() =>
                      handleSelectCurrency(item.currency)
                    }
                  >
                    <span>{item.currency}</span>

                    <strong>
                      {formatMoney(item.balance)}
                    </strong>
                  </button>
                );
              })}
            </div>
          )}
        </div>

        {/* PROFIT PERCENTAGE */}
        <div className="profit-display">
          <span>0.00%</span>
        </div>
      </div>

      {/* TODAY'S PROFIT */}
      <div className="profit-label">
        {t.todaysProfit}
      </div>

      {/* BUTTONS */}
      <div className="balance-buttons">
        <button
          type="button"
          className="deposit-btn"
          onClick={handleDeposit}
        >
          <FaWallet />
          <span>{t.deposit}</span>
        </button>

        <button
          type="button"
          className="sports-btn"
          onClick={handleMarketTrade}
        >
          <FaFutbol />
          <span>{t.marketTrade}</span>
        </button>
      </div>
    </div>
  );
};

export default BalanceCard;